import { Component, input } from '@angular/core';

@Component({
  selector: 'empathy-viewer-card',
  templateUrl: 'card.component.html',
  styleUrls: ['card.component.scss', '_card-theme.component.scss']
})
export class EmpathyCardComponent {
  noTitle = input<boolean>(false);
  fullSize = input<boolean>(false);
  fitBox = input<boolean>(false);
  style = input<'light' | 'medium' | 'transparent'>('light');
  title = input<string>('');
}
